import {Box, Container, Tab, Tabs, Typography} from '@mui/material';
import {useState} from 'react';
import TabPanel from '../components/TabPanel';
import UsersList from '../components/UsersList';
import SettingsForm from '../components/SettingsForm';
import TopicsList from '../components/TopicsList';
import WebhooksList from '../components/WebhooksList';

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

export default function Settings() {
    // const { data, error, mutate, isFetching } = useFetch('/config');
    const [value, handleChange] = useState(0);

    return (
        <Container fixed>
            <Typography variant="h5" component="h2" my={3}>
                Configurações
            </Typography>

            <Box sx={{borderBottom: 1, borderColor: 'divider'}}>
                <Tabs value={value} onChange={(e, index) => handleChange(index)}>
                    <Tab label="Configurações" {...a11yProps(0)} />
                    <Tab label="Webhooks Asaas" {...a11yProps(1)} />
                    {/* <Tab label="Usuários" {...a11yProps(1)} /> */}
                    {/* <Tab label="Tópicos" {...a11yProps(1)} /> */}
                </Tabs>
            </Box>
            <TabPanel value={value} index={0}>
                <SettingsForm />
            </TabPanel>
            <TabPanel value={value} index={1}>
                <WebhooksList />
            </TabPanel>
            {/* <TabPanel value={value} index={1}>
                <UsersList />
            </TabPanel> */}
            {/* <TabPanel value={value} index={1}>
                <TopicsList />
            </TabPanel> */}
        </Container>
    );
}
